package com.milta.core.localization.translations.de

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Neue Lieferung",
    manualDeliverySubtitle = "Fügen Sie der Tour eine Lieferung hinzu",
    recipientNameLabel = "Name des Empfängers",
    addressLabel = "Adresse",
    phoneNumberLabel = "Telefon",
    deliveryTimeLimitLabel = "Zeitlimit",
    optionalSuffix = "(optional)",
    submitButton = "Hinzufügen und weiter",
    saveEditedDeliveryButton = "Änderung speichern",
    deliveryCreated = "Lieferung hinzugefügt",
    errorRecipientNameRequired = "Der Name des Empfängers ist erforderlich",
    errorRecipientNameTooLong = "Der Name ist zu lang (max. 150 Zeichen)",
    errorAddressRequired = "Die Adresse ist erforderlich",
    errorAddressTooLong = "Die Adresse ist zu lang (max. 255 Zeichen)",
    errorPhoneTooLong = "Die Telefonnummer ist zu lang (max. 20 Zeichen)",
    errorDuplicateDelivery = "Diese Lieferung ist bereits in der Liste (gleicher Empfänger und Adresse)",
    errorRouteNotFound = "Tour nicht gefunden",
    errorForbidden = "Sie sind nicht berechtigt, diese Tour zu bearbeiten",
    errorValidation = "Bitte überprüfen Sie die eingegebenen Felder",
    errorGeneric = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    errorRouteNotInProgress = "Diese Tour läuft nicht mehr. Es kann keine Lieferung mehr hinzugefügt werden.",
    unknownRecipientLabel = "Unbekannt",
    driverHomeTitle = "Meine Tour",
    driverModeBadge = "Fahrermodus",
    routeStatusScheduled = "Geplant",
    routeStatusInProgress = "Läuft",
    routeStatusCompleted = "Abgeschlossen",
    routeStatusPartial = "Teilweise",
    driversDepartedOne = "gestartet",
    driversDepartedMany = "gestartet",
    driversFinishedOne = "fertig",
    driversFinishedMany = "fertig",
    stopsDeliveredLabel = "Geliefert",
    stopsInProgressLabel = "Unterwegs",
    stopsTodoLabel = "Offen",
    stopsFailedLabel = "Fehlgeschlagen",
    stopsUntreatedLabel = "Nicht bearbeitet",
    stopsCountLabel = "Stopps",
    startRouteButton = "Tour starten",
    noRouteTitle = "Keine Tour",
    noRouteSubtitle = "Ihnen ist derzeit keine Tour zugewiesen.",
    noRoutePastSubtitle = "Für dieses Datum wurde Ihnen keine Tour zugewiesen.",
    routeInProgressTitle = "Tour läuft",
    routeCompletedTitle = "Tour abgeschlossen",
    addStopButton = "Stopp hinzufügen",
    errorConflict = "Die Tour wurde bereits gestartet oder abgeschlossen.",
    greetingPrefix = "Hallo",
    routeOfTheDayLabel = "TOUR DES TAGES",
    noOtherRouteLabel = "Keine weitere Tour geplant",
    routeLabel = "Tour",
    importMenuTitle = "Lieferungen importieren",
    importMenuSubtitle = "Mehrere Modi kombinierbar — wählen Sie eine Quelle",
    importModeScanDocumentTitle = "Dokument scannen",
    importModeScanDocumentDesc = "Fotografieren Sie eine Liste oder ein Paketetikett",
    importModePdfTitle = "PDF importieren",
    importModePdfDesc = "Lieferscheine, gescannte Datei",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Ihr eigenes Format — Spalten werden automatisch erkannt",
    importModeManualTitle = "Manuelle Eingabe",
    importModeManualDesc = "Name, Adresse, Telefon, Zeitlimit",
    photoSourceSheetTitle = "Wie möchten Sie das Foto hinzufügen?",
    photoSourceTakePhoto = "Foto aufnehmen",
    photoSourceChooseGallery = "Aus der Galerie auswählen",
    photoSourceChooseFiles = "Bild aus Dateien wählen",
    createRouteTitle = "Tour erstellen",
    routeCardDetailLabel = "Detail",
    importReviewTitle = "Importierte Lieferungen prüfen",
    importReviewMissingGpsWarning = "GPS-Koordinaten fehlen",
    importReviewRetryGeocodeAction = "Geokodierung wiederholen",
    createRouteEmptyDrivers = "Noch keine Fahrer in Ihrem Team",
    editDeliveriesAction = "Bearbeiten",
    moreDeliveriesLabel = "weitere",
    addDeliveriesAction = "Lieferungen hinzufügen",
    manualEntryAddedConfirmPrefix = "Lieferung hinzugefügt:",
    manualEntryMergedConfirmPrefix = "Paket zur bestehenden Lieferung hinzugefügt",
    manualEntryAddedCountLabel = "Hinzugefügte Lieferungen",
    manualEntryFinishButton = "Fertig",
    optimizeRouteButton = "Route optimieren",
    createRouteButtonNoOptimize = "Route erstellen",
    errorNoEnterprise = "Ihrem Konto ist kein Unternehmen zugeordnet",
    errorDriverNotFound = "Fahrer nicht gefunden",
    errorNoDeliveries = "Fügen Sie mindestens eine Lieferung hinzu, bevor Sie die Route optimieren",
    errorOptimizationUnavailable = "Der Optimierungsdienst ist derzeit nicht verfügbar.",
    errorGeocodingFailed = "Einige Lieferadressen konnten nicht gefunden werden. Bearbeiten Sie die Adresse und versuchen Sie es erneut.",
    dispatchTitle = "Optimierung",
    optimizedSuccessTitle = "Route optimiert!",
    optimizedSuccessSubtitleSuffix = "Stopps für die kürzeste Route sortiert",
    stopsStatLabel = "Stopps",
    stopDetailTitlePrefix = "Stopp",
    stopStatusCurrentLabel = "Läuft",
    stopStatusUpcomingLabel = "Bevorstehend",
    stopStatusDeliveredLabel = "Zugestellt",
    stopStatusFailedLabel = "Fehlgeschlagen",
    stopRecipientLabel = "Empfänger",
    callActionLabel = "Anrufen",
    noPhoneLabel = "Keine Telefonnummer angegeben",
    packagesCountLabel = "Pakete",
    navigateButton = "Navigieren",
    navigationUnavailableUnverifiedAddress = "Adresse nicht verifiziert: Navigation für diesen Stopp nicht verfügbar.",
    deadlineBeforePrefix = "Vor",
    deadlinePastSuffix = "überfällig",
    validateStopAction = "Diesen Stopp bestätigen",
    teamDashboardTitle = "Touren",
    todayDateLabel = "Heute",
    statRoutesLabel = "Touren",
    statDeliveriesLabel = "Lieferungen",
    statCompletedLabel = "Abgeschlossen",
    teamSectionTitle = "Team",
    routeStartedAtPrefix = "Gestartet um",
    routeCompletedAtPrefix = "Abgeschlossen um",
    routeNotStartedLabel = "Nicht gestartet",
    emptyTeamRoutesTitle = "Keine Tour an diesem Tag",
    emptyTeamRoutesSubtitle = "Kein Fahrer im Team hat für dieses Datum eine geplante Tour.",
    errorInvalidDate = "Ungültiges Datum",
    routeDetailTitle = "Tourdetails",
    driverEyebrowLabel = "Fahrer",
    failedDeliveryTag = "Lieferung fehlgeschlagen",
    driverLoadingCheckTitle = "Ladekontrolle",
    loadingCheckInstructionText = "Prüfen Sie, ob alle vorgesehenen Pakete im Fahrzeug geladen sind, bevor Sie losfahren.",
    expectedPackagesLabel = "für diese Tour vorgesehene Pakete",
    confirmLoadCheckboxPrefix = "Ich habe alle",
    confirmLoadCheckboxSuffix = "für diese Tour vorgesehenen Pakete geladen",
    reportDiscrepancyToggleLabel = "Abweichung melden",
    discrepancyNotePlaceholder = "Z. B.: Ich habe 9 Pakete statt 11 geladen…",
    discrepancyNoteTooLong = "Notiz zu lang — maximal 500 Zeichen.",
    undeliveredStopsSectionTitle = "Nicht abgeholte Pakete — aus der Tour entfernen",
    removedStopNoticePrefix = "„",
    removedStopNoticeMiddle = "\" aus der Tour entfernt — 1 Stopp weniger",
    remainingStopsSuffix = "verbleibend",
    confirmAndStartButton = "Bestätigen und Tour starten",
    loadingOnBehalfOfLabel = "Im Auftrag von",
    loadingExpectedLabel = "Geplante Ladung",
    loadingQuestionTitle = "Haben Sie alle Pakete geladen?",
    loadingAllLoadedPrefix = "Ja, alle",
    loadingAllLoadedSuffix = "Pakete sind an Bord",
    loadingIncompleteOption = "Unvollständige Ladung",
    loadingIncompleteHint = "Ich entferne die betroffenen Stopps oder begründe es",
    loadingIncompleteRemoveLabel = "Und/oder entfernen Sie die nicht geladenen Stopps",
    slideToStartLabel = "Zum Starten schieben",
    completeRouteButton = "Tour abschließen",
    completeRouteDialogTitle = "Tour abschließen?",
    completeRouteDialogPendingCountSuffix = "Lieferungen wurden noch nicht bearbeitet",
    completeRouteDialogPendingNote = "Sie werden mit dem unten angegebenen Grund als fehlgeschlagen markiert. Sie sind für diese unbearbeiteten Lieferungen verantwortlich.",
    completeRouteDialogBody = "Diese Aktion ist endgültig: Die Tour erhält den Status „Abgeschlossen\" und kann nicht mehr geändert werden.",
    completeRouteDialogBodyAllTreated = "Alle Lieferungen wurden bearbeitet. Die Tour erhält den Status „Abgeschlossen\" und kann nicht mehr geändert werden.",
    completeRouteDialogConfirm = "Abschließen",
    completeRouteDialogReasonLabel = "Grund (optional)",
    completeRouteDialogReasonPlaceholder = "Erklären Sie, warum diese Lieferungen nicht bearbeitet wurden…",
    completeRouteDialogNoReasonWarning = "Ohne Angabe eines Grundes werden die verbleibenden Stopps als nicht zugestellt erfasst – zulasten des Transporteurs.",
    routeCompletedMessage = "Tour abgeschlossen.",
    stopStatusUntreatedLabel = "Unbearbeitet",
    errorCompleteRouteStatusConflict = "Diese Tour kann in ihrem aktuellen Zustand nicht abgeschlossen werden.",
    errorCompleteRoutePendingStopsConflict = "Einige Lieferungen sind noch offen. Bestätigen Sie, um trotzdem abzuschließen.",
    stopSearchOpenAction = "Stopp suchen",
    stopSearchCloseAction = "Suche schließen",
    stopSearchPlaceholder = "Name, Adresse oder Telefon",
    stopSearchClearTextAction = "Text löschen",
    stopSearchResultCount = "%1 von %2 Stopps",
    stopSearchResultCountOne = "1 von %1 Stopps",
    stopSearchEmptyTitle = "Kein passender Stopp",
    stopSearchEmptyHint = "Prüfen Sie die Schreibweise oder suchen Sie nach Adresse oder Telefon.",
    stopSearchClearAction = "Suche löschen",
    stopPositionLabel = "Nr. %1",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Anzahl der Pakete",
    reoptimizeSuccessTitle = "Route neu optimiert",
    backToRouteButton = "Zurück zur Tour",
    routeBatchMultiDriverLink = "Auf mehrere Fahrer verteilen",
    routeBatchSelectTitle = "Tour aufteilen",
    routeBatchDeliveriesReadyLabel = "Lieferungen bereit zur Aufteilung",
    routeBatchDriversSectionTitle = "Fahrer",
    routeBatchDriversSelectedSuffix = "Fahrer ausgewählt",
    routeBatchOptimizeToggleTitle = "Route optimieren",
    routeBatchOptimizeToggleHelp = "RoutaR teilt und ordnet die Stopps nach Entfernung. Deaktiviert: einfache Aufteilung nach Stoppanzahl, ohne Routenberechnung.",
    routeBatchSubmitButtonPrefix = "Aufteilen auf",
    routeBatchDriversWord = "Fahrer",
    routeBatchOptimizationUnavailable = "Optimierungsdienst derzeit nicht verfügbar. Die Tour wurde nicht erstellt — überprüfen Sie Ihre Verbindung und versuchen Sie es erneut, oder deaktivieren Sie „Route optimieren\" für eine sofortige einfache Aufteilung.",
    routeBatchPreviewTitle = "Vorschau der Aufteilung",
    routeBatchPreviewEyebrowMiddle = "Lieferungen aufgeteilt auf",
    routeBatchPreviewEyebrowSuffix = "Fahrer",
    routeBatchStopsChipSuffix = "Stopps",
    routeBatchDistanceLabel = "Entfernung",
    routeBatchDurationLabel = "Geschätzte Dauer",
    routeBatchDistanceNotCalculated = "Nicht berechnet",
    routeBatchOptimizeDisabledBanner = "Optimierung deaktiviert: gleichmäßige Aufteilung nach Stoppanzahl, ohne Berechnung von Entfernung oder Reihenfolge.",
    routeBatchReoptimizeButton = "Neu optimieren",
    routeBatchDispatchButton = "Bestätigen und senden",
    errorRouteBatchAlreadyDispatched = "Dieses Los wurde bereits an die Fahrer gesendet — es kann nicht mehr geändert werden.",
    routeBatchDispatchedTitle = "Touren gesendet!",
    routeBatchDispatchedSubtitleSuffix = "Fahrer gleichzeitig benachrichtigt, jeweils mit ihrer eigenen geplanten Tour.",
    routeBatchStatRoutesLabel = "Touren",
    routeBatchStatDeliveriesLabel = "Lieferungen",
    routeBatchStatusLabel = "Status",
    routeBatchStatusDispatchedValue = "Gesendet",
    routeBatchSentAtLabel = "Gesendet am",
    routeBatchPerDriverTitle = "Details pro Fahrer",
    routeBatchDriverScheduledStatus = "Geplant",
    routeBatchBackToHomeButton = "Zurück zur Startseite",
    errorTooManyDrivers = "Sie können nicht mehr als 50 Fahrer gleichzeitig auswählen.",
    errorTooManyDeliveries = "Ein Los darf 500 Lieferungen nicht überschreiten.",
    createRouteFabLabel = "Neue Tour",
    createOwnRouteButtonLabel = "Meine Tour erstellen / optimieren",
    createOwnRouteTitle = "Meine Tour erstellen",
    createOwnRouteDeliveriesCountSuffix = "Lieferungen bereit",
    stopStatusEnRouteLabel = "Unterwegs",
    yesterdayDateLabel = "Gestern",
    periodPastLabel = "Vergangen",
    periodTomorrowLabel = "Morgen",
    viewRouteButton = "Tour anzeigen",
    viewButton = "Anzeigen",
    noRouteTomorrowTitle = "Für morgen ist nichts geplant",
    noRouteTomorrowSubtitle = "Planen Sie eine Tour im Voraus, damit sie morgen früh direkt bereit ist.",
    planRouteButtonLabel = "Tour planen",
    myRoutesTodayTitle = "Ihre heutigen Touren",
    myRoutesTitle = "Ihre Touren",
    weekdayShortNames = listOf("Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"),
    weekdayFullNames = listOf("Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"),
    monthNames = listOf("Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"),
    statRoutesTodayLabel = "Touren heute",
    statStopsTodayLabel = "Stopps heute",
    statOnTimeLabel = "Pünktlich heute",
    statAvgProgressLabel = "Durchschnittlicher Fortschritt",
    inProgressSectionTitle = "Läuft",
    upcomingSectionTitle = "Bevorstehend",
    doneSectionTitle = "Abgeschlossen",
    seeAllLabel = "Alle anzeigen",
    continueRouteButton = "Tour fortsetzen",
    detailsLinkLabel = "Details",
    deliveryProofTitle = "Lieferung bestätigen",
    deliveryProofStatusSectionLabel = "Lieferstatus",
    deliveryProofPhotoSectionLabel = "Nachweisfoto",
    deliveryProofPhotoHint = "Zur Bestätigung erforderlich",
    deliveryProofTakePhotoCta = "Foto aufnehmen",
    deliveryProofRetakePhotoCta = "Foto erneut aufnehmen",
    deliveryProofRetakeChipLabel = "Erneut aufnehmen",
    deliveryProofCommentSectionLabel = "Kommentar",
    failureReasonRouteClosedByDriver = "Tour vom Fahrer beendet: Stopp nicht zugestellt, zulasten des Transporteurs.",
    deliveryProofCommentRequiredSuffix = "bei Fehlschlag erforderlich",
    deliveryProofCommentPlaceholderOptional = "Optional — Details zur Lieferung…",
    deliveryProofCommentPlaceholderRequired = "Erklären Sie den Grund für den Fehlschlag…",
    deliveryProofCommentRequiredError = "Bei einer fehlgeschlagenen Lieferung ist ein Kommentar erforderlich",
    deliveryProofSubmitButton = "Lieferung bestätigen",
    deliveryProofErrorInvalidPhoto = "Foto unleserlich oder Format nicht unterstützt. Nehmen Sie das Foto erneut auf und versuchen Sie es erneut.",
    deliveryProofAlreadyProcessedBanner = "Dieser Stopp wurde bereits bearbeitet und kann nicht mehr geändert werden.",
    proofPhotoViewerDownloadLabel = "Herunterladen",
    proofPhotoViewerCloseLabel = "Schließen",
    proofPhotoDownloadedMessage = "Foto in der Galerie gespeichert.",
    proofPhotoDownloadErrorMessage = "Foto konnte nicht gespeichert werden.",
    deliveryConfirmTitle = "Lieferung bestätigt",
    deliveryConfirmSuccessTitle = "Lieferung bestätigt",
    deliveryConfirmSuccessSubtitle = "Der Nachweis wurde für diesen Stopp gespeichert.",
    deliveryConfirmFailedTitle = "Fehlschlag erfasst",
    deliveryConfirmFailedSubtitle = "Der Kommentar und das Foto wurden an den Verantwortlichen übermittelt.",
    deliveryConfirmRouteCompletedTitle = "Tour abgeschlossen!",
    deliveryConfirmRouteCompletedSubtitle = "Alle Stopps wurden bearbeitet.",
    deliveryConfirmValidatedAtLabel = "Bestätigt am",
    deliveryConfirmNextStopEyebrowPrefix = "Nächster Stopp",
    deliveryConfirmGoToNextStopButton = "Zum nächsten Stopp",
    deliveryConfirmAllDoneMessage = "Das war der letzte Stopp der Tour — denken Sie daran, sie abzuschließen.",
    offlineBannerTitle = "Offline",
    offlineBannerRouteSubtitle = "Ihre Bestätigungen werden gesendet, sobald das Netzwerk wieder verfügbar ist",
    offlineBannerValidateSubtitle = "wird lokal gespeichert",
    offlineSyncingBannerTitle = "Synchronisierung läuft",
    offlineSyncingSubtitleSuffix = "Lieferungen gesendet",
    offlineRetryBannerTitle = "Synchronisierung fehlgeschlagen",
    offlineRetryBannerSubtitle = "nächster Versuch bei der nächsten Netzwerkverbindung",
    offlineSyncSuccessToastSuffix = "Lieferungen erfolgreich synchronisiert",
    offlineQueuedBadgePendingLabel = "Wartet auf Versand",
    offlineQueuedBadgeSyncingLabel = "Wird gesendet",
    offlineQueuedBadgeFailedLabel = "Fehlgeschlagen — erneuter Versuch geplant",
    offlineQueuedBadgeConflictLabel = "Bereits anderweitig bearbeitet",
    offlineDismissConflictAction = "Ausblenden",
    offlineValidatedLocallyAtPrefix = "lokal gespeichert um",
    offlineAddStopRequiresConnectionSuffix = "(erfordert eine Verbindung)",
    deliveryProofOfflineSubmitButton = "Speichern (spätere Synchronisierung)",
    deliveryProofSavedLocallyTitle = "Lokal gespeichert",
    deliveryProofSavedLocallySubtitle = "Diese Lieferung wird automatisch gesendet, sobald die Verbindung wiederhergestellt ist.",
    routeScheduledBannerTitle = "Route noch nicht gestartet",
    routeScheduledBannerSubtitle = "Starten Sie die Route, um eine Lieferung bestätigen zu können.",
    geocodeIssueTag = "Adresse nicht gefunden",
    regeocodeAction = "Geolokalisierung erneut versuchen",
    regeocodeSuccessMessage = "Adressen aktualisiert",
    dashboardTitle = "Dashboard",
    viewAllAction = "Alle anzeigen",
    deleteRouteDialogTitle = "Diese Tour löschen?",
    deleteRouteDialogMessage = "Diese Tour wird endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    errorRouteDeleteConflict = "Löschen nicht möglich: Die Tour läuft gerade.",
    errorDriverHasActiveRoute = "Eine andere Tour läuft derzeit. Schließen Sie diese ab, bevor Sie eine neue starten.",
    routeBatchNoStopsTag = "Keine Stopps",
    routeBatchNoStopsDialogTitle = "Fahrer ohne Stopps",
    routeBatchNoStopsDialogMessage = "Mindestens ein Fahrer hat keinen Stopp zugewiesen. Er erhält trotzdem eine leere Route, wenn er nicht aus dieser Charge entfernt wird. Trotzdem senden?",
    routeBatchAddressesToReviewTag = "Adresse(n) zu überprüfen",
    otherDeliveriesInImportLabel = "Weitere Lieferungen dieses Imports",
    proofPhotoUnavailableLabel = "Foto nicht verfügbar",
    deliveryProofPhotoOptionalSectionLabel = "Foto (optional)",
    proofWithoutPhotoLabel = "Ohne Foto",
    removeStopDialogTitle = "Diesen Stopp entfernen?",
    removeStopDialogMessage = "„{name}“ ({count} Pakete) wird aus der Tour entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
    deliveryRemovedMessage = "Lieferung entfernt",
    undoAction = "Rückgängig",
    callLaunchFailed = "Der Anruf kann auf diesem Gerät nicht gestartet werden",
    keepDraftsDialogTitleOne = "Die Lieferung behalten?",
    keepDraftsDialogTitleMany = "Die {count} Lieferungen behalten?",
    keepDraftsDialogMessage = "Sie haben sie erfasst, aber sie sind noch nicht in der Liste.",
    keepDraftsAction = "Behalten",
    deliveriesAddedToRouteOne = "1 Lieferung zur Tour hinzugefügt",
    deliveriesAddedToRouteMany = "{count} Lieferungen zur Tour hinzugefügt",
    driverJoinedTeamMessage = "{name} ist dem Team beigetreten",
    ownRouteCreatedNotOptimizedMessage = "Tour in der eingegebenen Reihenfolge erstellt: Die Optimierung war nicht möglich",
    draftExitTitle = "Erstellung verlassen?",
    draftExitMessageOne = "Sie haben 1 Lieferung hinzugefügt ({packages} Pakete).",
    draftExitMessageMany = "Sie haben {count} Lieferungen hinzugefügt ({packages} Pakete).",
    draftKeepAction = "Für später behalten",
    draftDeleteDeliveriesAction = "Lieferungen löschen",
    draftContinueAction = "Erstellung fortsetzen",
    draftSavedMessage = "Entwurf gespeichert",
    draftCardTitle = "Tour in Erstellung",
    draftForDate = "für den {date}",
    draftResumeAction = "Fortsetzen",
    draftDeleteDialogTitle = "Entwurf löschen?",
    draftDeleteDialogMessageOne = "Die bereits erfasste Lieferung ({packages} Pakete) wird gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    draftDeleteDialogMessageMany = "Die {count} bereits erfassten Lieferungen ({packages} Pakete) werden gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    draftResumeImportTitle = "Laufende Tour fortsetzen",
    draftImportAddsHint = "Importierte Lieferungen werden diesem Entwurf hinzugefügt:",
    stopDeliveredAtPrefix = "Zugestellt um",
    stopFailedAtPrefix = "Fehlgeschlagen um",
    stopOnTimeLabel = "Pünktlich",
    stopLateByPrefix = "Verspätet um",
    stopTimeLabel = "Zeit",
    stopAfterStartSuffix = "nach dem Start",
    stopAfterPreviousSuffix = "nach dem vorherigen Stopp",
    stopDriverCommentLabel = "Kommentar des Fahrers",
    stopPackagesLabel = "Pakete",
    durationHoursUnit = "Std.",
    durationMinutesUnit = "Min.",
    ),
)
